<template>
  <div>
    <a-g-speakol-table
      ref="advertiserTransactions"
      :columns="agColumns"
      :options="agOptions">
    </a-g-speakol-table>
  </div>
</template>

<script>

import AdvertisersTransactionsDataSource from '@/datasources/AdvertiserTransactionsDataSource'

import AGSpeakolTable from '@/components/AGSpeakolTable'

import TransactionDate from './components/TransactionDate'
import TransactionDownloadPDF from './components/TransactionDownloadPDF'
import TransactionAmount from './components/TransactionAmount'

import '@/filters/Transaction.js'

export default {
  components: {
    AGSpeakolTable,
    TransactionDate,
    TransactionAmount,
    TransactionDownloadPDF
  },
  data () {
    return {
      agOptions: this.getTableOptions(),

      agColumns: this.getTableColumns()
    }
  },

  methods: {
    getTableOptions () {
      return {
        dataSource: AdvertisersTransactionsDataSource
      }
    },

    getTableColumns () {
      return [
        {
          headerName: 'Date',
          field: 'created_at',
          minWidth: 250,
          cellRendererFramework: 'TransactionDate',
          sortable: true
        },
        {
          headerName: 'Description',
          field: 'description',
          minWidth: 200,
          sortable: true
        },
        {
          headerName: 'Via',
          field: 'via',
          minWidth: 200,
          sortable: true
        },
        {
          headerName: 'Amount',
          field: 'balance',
          minWidth: 200,
          sign: '$',
          cellRendererFramework: 'TransactionAmount',
          sortable: true
        },
        {
          headerName: 'Added By',
          field: 'addedByName',
          minWidth: 250,
          sortable: true
        },
        {
          headerName: 'Payment Receipt',
          field: 'download_receipt',
          minWidth: 200,
          cellRendererFramework: 'TransactionDownloadPDF'
        }
      ]
    }
  }
}
</script>
